import type {
  BetterstartIntegrationDefinition,
  BetterstartIntegrationId
} from '@cli-types/integration-engine/integrations.js'
import { createRegistry } from '@core-engine/installable/registry.js'
import { mailchimpIntegration } from '@next-adapter/integrations/mailchimp/integration.js'
import { r2Integration } from '@next-adapter/integrations/r2/integration.js'
import { railwayBucketIntegration } from '@next-adapter/integrations/railway-bucket/integration.js'
import { resendIntegration } from '@next-adapter/integrations/resend/integration.js'
import { vercelBlobIntegration } from '@next-adapter/integrations/vercel-blob/integration.js'

export const integrationRegistry: Record<string, BetterstartIntegrationDefinition> = {
  mailchimp: mailchimpIntegration,
  resend: resendIntegration,
  r2: r2Integration,
  'railway-bucket': railwayBucketIntegration,
  'vercel-blob': vercelBlobIntegration
}

const integrations = createRegistry<BetterstartIntegrationDefinition, BetterstartIntegrationId>(
  integrationRegistry,
  'integration'
)

export const listIntegrationDefinitions = integrations.list
export const getIntegrationDefinition = integrations.get
export const isIntegrationId = integrations.is
export const formatUnknownIntegrationMessage = integrations.formatUnknownMessage

export function isEmailProviderIntegration(integrationId: BetterstartIntegrationId): boolean {
  return Boolean(getIntegrationDefinition(integrationId).capabilities?.emailProvider)
}
